import {
  REQUEST_FUNERAL_LIST
  ,REQUEST_CAMPAIGN_LIST
  ,REQUEST_INVITATION_DETAIL
  ,REQUEST_CAMPAIGN_DETAIL
} from './mutation-types';
  
import axiosInst from '@/utility/axiosInst';
  
export default {

  requestFuneralApiGuideList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/partners/page-partner-with-details", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_FUNERAL_LIST, res.data)
    })
  },
  requestCampaignApiList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/campaign/page-campaign-with-details", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_LIST, res.data)
    })
  },
  requestInvitationApiDetail({commit}, orderNum) {
    return axiosInst.springAxiosInst.get(`/company/invitation/info/${orderNum}`)
    .then((res) => {
      commit(REQUEST_INVITATION_DETAIL, res.data)
    })
  },
  requestCampaignApiDetail({commit}, invitationSeq) {
    return axiosInst.springAxiosInst.get(`/company/campaign/info/${invitationSeq}`)
    .then((res) => {
      commit(REQUEST_CAMPAIGN_DETAIL, res.data)
      return res.data;
    })
  },
  requestFuneralInvitationEditApi({}, payload){
    return axiosInst.springAxiosInst.post('/company/funeral-edit', payload).then(res => {
      return res.data
    })
  }

}